import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups"
import FieldReadOnly from "../../../generic/read-only-value/read-only"
import FieldConfig from "../../../proto/field-config"
import FieldBaseline_View from "./render/view"

export default class FieldBaseline extends FieldReadOnly {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Baseline";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Item baseline result action"

        this.icon               = 'i5-snapshot'

        _.assign(this.renderComponents, {
            view                : FieldBaseline_View,
            viewSmall           : FieldBaseline_View,
        })
    }
}
